export const hiddenAnchorStyle = {
    color: 'inherit',
    textDecoration: 'none'
};

export const optionListItemStyle = {
  listStyle: 'none',
  lineHeight: 2,
  marginTop: 10
}

export const pretendAnchorStyle = {
  color: '#3cb7e3',
  textDecoration: 'none'
}

export const softButtonStyle = {
  backgroundColor: 'inherit',
  boxShadow: "none",
  appearance: "none",
  border: "none"
}


// WEBPACK FOOTER //
// ./src/Components/checkout/components/styles.js